import { useCurrentUser } from '../auth.js';

/**
 * Marking the reader's own franchise in a table.
 *
 * Every table on the site identifies a franchise by Sleeper user id rather than
 * by name — see `StatRow` — and an account carries the id it plays as, so the
 * two line up without matching on anything a manager can rename. A signed-out
 * reader, or one nobody has linked to a Sleeper account, simply has no row of
 * their own and sees the tables exactly as before.
 *
 * The highlight is a tint plus a word, never colour alone.
 */

/** The Sleeper user id the signed-in reader plays as, if there is one. */
export function useOwnSleeperId(): string | null {
  return useCurrentUser()?.sleeperUserId ?? null;
}

/** Row classes for a table row, tinted when it belongs to the reader. */
export function ownRowClass(mine: boolean): string {
  return mine
    ? 'bg-brass-400/[0.14] shadow-[inset_3px_0_0_0_#a5d62e] hover:bg-brass-400/20'
    : 'hover:bg-white/[0.05]';
}

/** The badge that sits beside the reader's own team name. */
export function OwnTeamMark() {
  return (
    <span
      className="ml-1.5 bg-brass-400 px-1.5 py-0.5 align-middle font-display text-[0.625rem]
        font-bold uppercase tracking-bug text-field-950"
    >
      You
    </span>
  );
}
